import * as React from "react";

interface Props {
  isBadgeShowing?: boolean;
}

const EmptyPatientRoster: React.FC<Props> = ({ isBadgeShowing = false }) => {
  return (
    <div
      className="loading-container"
      style={{ height: isBadgeShowing ? "45vh" : "53.8vh" }}
    >
      <h3>No patients found</h3>
      <p>Try adjusting your search or filters.</p>
    </div>
  );
};

export default EmptyPatientRoster;
